import * as React from "react";
import { Menu } from "antd";
import { Link, Route, Router, Switch } from "react-router-dom";
import SubMenu, { ISubMenuItem } from "components/SubMenu/SubMenu";
import Portfolio from "./Subpages/Portfolio/Portfolio";
import DeletedPortfolio from "./Subpages/DeletedPortfolio/DeletedPortfolio";

const subMenuItems: ISubMenuItem[] = [
  {
    label: "Portfolio",
    path: "/portfolio",
    Component: Portfolio,
  },
  {
    label: "Deleted Portfolio",
    path: "/deletedPortfolio",
    Component: DeletedPortfolio,
  },
];
export default function Find() {
  return (
    <SubMenu
      pathPrefix="/find"
      subMenuItems={subMenuItems}
    />
  );
}
